import React from "react";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";

export const FileUpload = ({ files, setFiles, name, className = null, maxFiles = 3, onWarning = () => {}, disabled = false }) => {
    return (
        <FilePond
            files={files}
            className={className}
            onupdatefiles={setFiles}
            allowMultiple={true}
            maxFiles={maxFiles}
            name={name}
            disabled={disabled}
            labelIdle='Drag & drop your files or <span class="filepond--label-action">browse</span>'
            onwarning={({ body }) => onWarning?.(body)}
        />
    );
};
